module.exports = function() {
  return new Worker(__webpack_public_path__ + "7ce900e787b3a8a30a82.worker.js");
};